module.exports = __webpack_public_path__ + "media/images/daopool-dac5fc2b.png";